import { InquiryCTA } from "./PlanEventModal";
import { Reveal } from "./Reveal";
import { GoldTrophy } from "./GoldTrophy";

export const CtaBand = ({ title = "Let's Create Something Unforgettable", text = "Tell us about your event and we'll take it from there.", ctaLabel = "Plan Your Event", testId = "cta-band", animated = false }) => (
  <section className={`relative overflow-hidden text-black grain ${animated ? "cta-animated" : "bg-en-yellow"}`} data-testid={testId}>
    {animated && (
      <div aria-hidden className="pointer-events-none absolute inset-0">
        {[["left-[8%] top-8", "w-8", "-0.5s"], ["right-[14%] top-10", "w-10", "-1.6s"], ["left-[40%] bottom-6", "w-6", "-2.4s"], ["right-[6%] bottom-10", "w-7", "-3.1s"]].map(([pos, w, d], i) => (
          <svg key={i} viewBox="0 0 24 24" className={`glow-star absolute ${pos} ${w} text-white`} style={{ "--d": d, "--t": `${2.8 + i * 0.4}s` }}><path d="M12 1.5 C12.8 7.5 16.5 11.2 22.5 12 C16.5 12.8 12.8 16.5 12 22.5 C11.2 16.5 7.5 12.8 1.5 12 C7.5 11.2 11.2 7.5 12 1.5 Z" fill="currentColor" /></svg>
        ))}
      </div>
    )}
    <img src="/images/logo-star.png" alt="" aria-hidden className="pointer-events-none absolute -right-16 -top-16 w-72 opacity-10 animate-float" />
    <GoldTrophy className="pointer-events-none absolute -bottom-10 -left-8 h-64 w-64 opacity-[0.07] sm:h-80 sm:w-80" data-testid={`${testId}-trophy-watermark`} />
    <div className="relative mx-auto flex max-w-7xl flex-col gap-8 px-5 py-20 sm:px-8 md:flex-row md:items-center md:justify-between lg:py-28">
      <Reveal>
        <p className="font-gothic uppercase tracking-[0.2em] text-xs sm:text-sm text-black/60 mb-3">Ready when you are</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] max-w-2xl">{title}</h2>
        <p className="mt-4 max-w-xl text-base sm:text-lg text-black/70">{text}</p>
      </Reveal>
      <Reveal delay={0.15}>
        <InquiryCTA label={ctaLabel} icon data-testid={`${testId}-plan-event-btn`} className="inline-flex items-center gap-2 rounded-full bg-black px-8 py-4 font-gothic uppercase tracking-wider text-sm text-white transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-en-teal" />
      </Reveal>
    </div>
  </section>
);
